<template>
    <div class="flex flex-wrap" id="admJimsTT">
        <div v-if="!dataLoading.section" class="w-full">
            <div class="w-full border px-6 py-2 mb-4 bg-gray-super-100 text-center" v-show="!dataLoading.section && form.symbol">
                <div class="w-full mb-2">
                    <strong>Trade ID #{{ form.id }}</strong>
                </div>
                <span v-if="!dataLoading.symbolQuotes">
                    <p class="text-md leading-none mb-1 font-bold text-blue-500">{{ symbolQuotes.contractFullName || symbolQuotes.symbolName }}</p>
                    <p class="text-sm font-bold leading-none">Last Price: {{ symbolQuotes.lastPrice }}</p>
                </span>
                <spinner class="-my-1" v-else></spinner>
            </div>
            <div v-if="errors.symbol" class="error">
                {{ errors.symbol[0] }}
            </div>

            <template v-if="!dataLoading.symbolQuotes">
                <div class="w-full bg-tan-200 border border-tan-500 p-3">
                    <div class="w-full">
                        <label for="direction">Is Trade Tracker Alert - Public?</label>
                        <toggle-switch class="ml-2" :value="form.public" :clickable="true" v-model="form.public"></toggle-switch>
                    </div>
                </div>

                <div class="flex flex-wrap mt-2 mb-2">
                    <div class="xs:w-full sm:w-1/2 md:w-1/4 pr-2 xs:pr-0">
                        <label for="category">Trade Tracker's Category:</label>
                        <select class="form-control form-control-sm form-input-modal" v-model="form.category_id" name="category" id="category">
                            <template v-for="category in pasCategories">
                            <option :value="category.id" v-if="category.active">{{ category.name }}</option>
                            </template>
                            <option value="">&plus; Create new Category...</option>
                        </select>
                    </div>
                    <div class="xs:w-full sm:w-1/2 md:w-1/4 pr-1 xs:pr-0 xs:mt-1 mt-0" v-if="!form.category_id">
                        <label for="custom-category">New Category Name:</label>
                        <input :class="{ 'is-invalid' : !form.category_id && errors.category_id }" class="form-input form-input-sm" type="text" v-model="form.custom_category" maxlength="30" placeholder="Enter a new category name...">
                        <div v-if="!form.category_id && errors.category_id" class="error">
                            {{ errors.category_id[0] }}
                        </div>
                    </div>
                </div>
                <div class="flex flex-wrap mt-2 mb-2">
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="quantity">Quantity</label>
                        <input :class="{ 'is-invalid' : errors.quantity }" class="form-input form-input-sm" type="number" v-model.number="form.quantity">
                        <div v-if="errors.quantity" class="error">
                            {{ errors.quantity[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-1 xs:pr-0">
                        <label for="direction">Market Direction:</label>
                        <select :class="{ 'is-invalid' : errors.direction }" class="form-control form-control-sm form-input-modal" v-model="form.direction" name="direction" id="direction">
                            <option value="U">Up</option>
                            <option value="D">Down</option>
                            <option value="N">Neutral</option>
                        </select>
                        <div v-if="errors.direction" class="error">
                            {{ errors.direction[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pl-1 xs:pl-0">
                        <label for="pattern">Chart Pattern</label>
                        <input :class="{ 'is-invalid' : errors.pattern }" class="form-input form-input-sm" type="text" v-model="form.pattern">
                        <div v-if="errors.pattern" class="error">
                            {{ errors.pattern[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pl-2 xs:pl-0">
                        <label for="strategy">Strategy</label>
                        <select :class="{ 'is-invalid' : errors.strategy }" v-model="form.strategy" class="form-control form-control-sm form-input-modal" id="strategy">
                            <template v-if='strategyType == "future"'>
                            <option value="Long">Long</option>
                            <option value="Short">Short</option>
                            </template>
                            <template v-else>
                            <option value="Buy">Buy</option>
                            <option value="Sell">Sell</option>
                            </template>
                        </select>
                        <div v-if="errors.strategy" class="error">
                            {{ errors.strategy[0] }}
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="entry_date">Entry Date</label>
                        <input :class="{ 'is-invalid' : errors.entry_date }" class="form-input" type="date" v-model="form.entry_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                        <div v-if="errors.entry_date" class="error">
                            {{ errors.entry_date[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="entry_price">Entry Price</label>
                        <input type="text" v-model="form.entry_price" class="form-input form-input-sm form-input-modal" :class="{ 'is-invalid': errors.entry_price }" />
                        <div v-if="errors.entry_price" class="error">
                            {{ errors.entry_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/4 pr-2 xs:pr-0">
                        <label for="exit_date">Exit Date</label>
                        <input class="form-input" type="date" v-model="form.exit_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                    </div>
                    <div class="xs:w-full w-1/4">
                        <label for="expiration_date">Expiration Date</label>
                        <input class="form-input" type="date" v-model="form.expiration_date" pattern="[0-9]{2}/[0-9]{2}/[0-9]{4}">
                    </div>
                </div>
                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="stop_loss">Stop Loss</label>
                        <input type="text" v-model="form.stop_loss" class="form-input form-input-sm form-input-modal" :class="{ 'is-invalid': errors.stop_loss }" />
                        <div v-if="errors.stop_loss" class="error">
                            {{ errors.stop_loss[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="target_price">Target Price</label>
                        <input type="text" v-model="form.target_price" class="form-input form-input-sm form-input-modal" :class="{ 'is-invalid': errors.target_price }" />
                        <div v-if="errors.target_price" class="error">
                            {{ errors.target_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3">
                        <label for="exit_price">Actual Exit Price</label>
                        <input type="text" v-model="form.exit_price" class="form-input form-input-sm form-input-modal" :class="{ 'is-invalid': errors.exit_price }" />
                        <div v-if="errors.exit_price" class="error">
                            {{ errors.exit_price[0] }}
                        </div>
                    </div>
                </div>

                <div class="flex flex-wrap mb-2">
                    <div class="xs:w-full w-1/3 pr-2 xs:pr-0">
                        <label for="current_price">Current Price</label>
                        <input type="text" v-model="form.current_price" class="form-input form-input-sm form-input-modal" :class="{ 'is-invalid': errors.current_price }" />
                        <div v-if="errors.current_price" class="error">
                            {{ errors.current_price[0] }}
                        </div>
                    </div>
                    <div class="xs:w-full w-1/3">
                        <label for="closed_profit_loss">Closed Out Profit/Loss</label>
                        <input id="closed_profit_loss" name="closed_profit_loss" class="form-input form-input-sm" type="number" v-model="form.closed_profit_loss" />
                    </div>
                </div>

                <spinner v-if="dataLoading.updating"></spinner>
                <div class="w-full mt-8 flex flex-wrap justify-between">
                    <button @click="handleOnUpdate" class="btn btn-yellow">Update</button>
                    <a href="/admin/jims-trade-tracker/" class="btn btn-default">Cancel</a>
                </div>

            </template>
        </div>
        <spinner v-else></spinner>

        <flash-message ref="flash"></flash-message>

    </div>
</template>

<script setup>
import { ref, watch, computed, onMounted } from 'vue';

import ToggleSwitch from '../../Elements/ToggleSwitch';

const props = defineProps({
    initialValues: {
        type: Object,
        default: () => ({}),
        required: false
    },
    pasCategories: {
        type: [Object, Array],
        required: false
    },
});

const $clone = (obj) => JSON.parse(JSON.stringify(obj));

const flash = ref(null);
const section = ref(props.initialValues.section || 'future');

const sectionQuotes = ref([]);
const symbolQuotes = ref({});

const dataLoading = ref({
    updating: false,
    section: props.initialValues.symbol ? false : true,
    symbolQuotes: props.initialValues.symbol ? true : false,
});

const form = ref({
    id: props.initialValues.id || null,
    category_id: props.initialValues.category_id || props.pasCategories[0].id,
    custom_category: '',
    symbol: props.initialValues.symbol || null,
    contract_name: props.initialValues.contract_name || null,
    direction: props.initialValues.direction || 'U',
    pattern: props.initialValues.pattern || null,
    current_price: props.initialValues.current_price || null,
    strategy: props.initialValues.strategy || 'Long',
    quantity: props.initialValues.quantity || null,
    entry_price: props.initialValues.entry_price || null,
    entry_date: toDateString(props.initialValues.entry_date) || toDateString(new Date()),
    closed_profit_loss: props.initialValues.closed_profit_loss || null,
    stop_loss: props.initialValues.stop_loss || '',
    target_price: props.initialValues.target_price || '',
    exit_date: toDateString(props.initialValues.exit_date),
    exit_price: props.initialValues.exit_price || '',
    expiration_date: toDateString(props.initialValues.expiration_date),
    public: (props.initialValues.public ? true : false) || false,
    unit_code: props.initialValues.unit_code || null,
});

const errors = ref({});

const strategyType = computed(() => {
    if (props.initialValues.strategy) {
        return (props.initialValues.strategy === 'Buy' || props.initialValues.strategy === 'Sell') ? 'other' : 'future';
    } else {
        return (section.value === 'future') ? 'future' : 'other';
    }
});

function toDateString(strValue) {
    if (!strValue) {
        return '';
    }
    var date = new Date(strValue).toISOString();
    return date.split('T')[0];
}

function handleOnUpdate() {
    dataLoading.value.updating = true;

    let data = $clone(form.value);
    if (!data.category_id) {
        data.category_id = '';
    }

    const formData = new FormData();
    for (const [key, value] of Object.entries(data)) {
        formData.append(key, value);
    }

    formData.set('public', form.value.public ? 'true' : 'false');

    const route = window.route('admin.jims-trade-tracker.update-raw', { jims_trade_tracker: form.value.id });
    errors.value = {};

    axios.post(route, formData)
        .then((response) => {
            window.location = window.route('admin.jims-trade-tracker.index');
        })
        .catch(error => {
            flash.value.error('Error saving «Jim\'s Trade Tracker» entry');
            errors.value = error.response.data.errors;
        })
        .finally(() => {
            dataLoading.value.updating = false;
        });
}

function getSymbolSelectQuotes() {
    const route = window.route('api.quotes.symbol-select');

    dataLoading.value.section = true;

    axios.post(route, { section: section.value })
        .then((response) => {
            sectionQuotes.value = response.data;
        }).catch(error => {
            console.error(error);
        }).then(() => {
            dataLoading.value.section = false;
        });
}

function getSymbolQuotes() {
    const route = window.route('api.quotes');

    dataLoading.value.symbolQuotes = true;

    const params = {
        symbol: form.value.symbol,
        fields: 'baseCode,symbol,symbolType,symbolName,contractFullName,contractMonthYear,lastPrice,tradeTime,contractExpirationDate,pointValue,unitCode',
        raw: true,
        after: 'getChartTitle'
    };

    axios.post(route, params)
        .then((response) => {
            symbolQuotes.value = response.data.data[0];
            // form.value.unit_code = symbolQuotes.value.unitCode;
        }).catch(error => {
            console.error(error);
        }).then(() => {
            dataLoading.value.symbolQuotes = false;
        });
}

// watch(() => symbolQuotes.value.raw?.lastPrice, (newLastPrice) => {
//     if (newLastPrice !== undefined) {
//         form.value.current_price = newLastPrice;
//     }
// });

watch(() => form.value.symbol, (newSymbol) => {
    if (newSymbol) {
        getSymbolQuotes();
    }
});

watch(section, () => {
    getSymbolSelectQuotes();
});

onMounted(() => {
    if (form.value.symbol) {
        getSymbolQuotes();
    } else {
        getSymbolSelectQuotes();
    }
});
</script>

<style lang="scss">
#admJimsTT {
    .selector-wrapper {
        display: flex;
        flex-wrap: wrap;

        select {
            width: 100%;
        }
    }

     #selectFutureSpreads {
        & > span {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: 100%;
        }
     }
     #selectFutureOptions {
        & > div,
        & > div {
            display: flex;
            flex-wrap: wrap;
        }
        select {
            width: auto;
        }
     }
}
</style>
